/**
 * Legacy preferred-attendance labels (pre working-hours policy).
 * Kept for HR/self-service detail display on older requests that still
 * stored preferred_days / preferred_timing.
 */

export const COURSE_REQUEST_DAY_OPTIONS = [
  { value: 'sunday', label: 'Sunday' },
  { value: 'saturday', label: 'Saturday' },
  { value: 'weekdays', label: 'Weekdays (Mon–Fri)' },
];

export const COURSE_REQUEST_TIMING_OPTIONS = [
  { value: 'morning', label: 'Morning' },
  { value: 'afternoon', label: 'Afternoon' },
  { value: 'evening', label: 'Evening' },
];

export const COURSE_SCHEDULE_PATTERN_OPTIONS = [
  { value: 'single_day', label: 'Single day' },
  { value: 'consecutive_days', label: 'Consecutive days' },
  { value: 'weekly_sunday', label: 'Every Sunday' },
  { value: 'weekly_saturday', label: 'Every Saturday' },
  { value: 'weekly_weekends', label: 'Every Saturday and Sunday' },
  { value: 'alternate_sundays', label: 'Alternate Sundays' },
  { value: 'custom', label: 'Custom schedule / refer to timetable' },
];

const dayLabelMap = Object.fromEntries(
  COURSE_REQUEST_DAY_OPTIONS.map((o) => [o.value, o.label]),
);
const timingLabelMap = Object.fromEntries(
  COURSE_REQUEST_TIMING_OPTIONS.map((o) => [o.value, o.label]),
);

export const formatPreferredDays = (days = []) =>
  (days || [])
    .map((d) => dayLabelMap[d] || String(d).replace(/^\w/, (c) => c.toUpperCase()))
    .filter(Boolean)
    .join(', ');

export const formatPreferredSessions = (timing = []) =>
  (timing || [])
    .map((t) => timingLabelMap[t] || String(t).replace(/^\w/, (c) => c.toUpperCase()))
    .filter(Boolean)
    .join(', ');

/**
 * Whether the given master course code offers a language choice
 * (e.g. CSOC providers commonly run native-language sessions).
 * `codes` is the backend-sourced list from capabilities
 * (`language_preference_course_codes`) — pass it in rather than
 * hardcoding, so the source of truth stays server-side.
 */
export const courseOffersLanguagePreference = (masterCourseCode, codes = []) =>
  Boolean(masterCourseCode) && (codes || []).includes(masterCourseCode);

export const isScheduleOnlyLegacyNote = (note = '') => {
  const normalized = String(note).trim().toLowerCase().replace(/\.$/, '');
  return (
    normalized === 'every sunday'
    || normalized === 'every saturday'
    || normalized === 'alternate sundays'
    || /^\d+\s+sundays?$/.test(normalized)
  );
};
